import { useState } from "react";
import toggle from "./toggle";
import MenuItem from "./menu-item";

function StudentLifeMenu(props) {
  const [isStudentMenu, toggleStudentMenu] = useState(false);
  const toggleFunction = () => {
    toggle(toggleStudentMenu, !isStudentMenu);
  };

  return (
    <div
      className={`block visible hidden lg:block absolute w-full inset-x bg-white z-10 py-8 border-b-4 border-yellow-500 ${
        props.cssClass || ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4">
        <ul className="flex flex-wrap -mx-2">
          <li className="w-full md:w-4/12 px-2">
            <ul className="">
              <li>
                <MenuItem
                  linkKey={"Explore Student Life"}
                  linkUrl={"/student-life"}
                  linkText={"Explore Student Life"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Find out what it’s like to live and learn on America’s most beautiful campus."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Residential Life"}
                  linkUrl={"/student-life/residential-life"}
                  linkText={"Residential Life"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Go behind the scenes of our living-learning communities"
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Residence Hall Tours"}
                  linkUrl={"/student-life/residential-life/dorm-tours"}
                  linkText={"Residence Hall Tours"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Experience life in our res halls through the eyes of current students."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Campus Dining"}
                  linkUrl={"/student-life/campus-dining"}
                  linkText={"Campus Dining"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "With tons of dining options, we have something for every appetite."
                  }
                />
              </li>
            </ul>
          </li>
          <li className="w-full md:w-4/12 px-2">
            <ul className="">
              <li className="py-2">
                <MenuItem
                  linkKey={"Diversity and Inclusion"}
                  linkUrl={"/student-life/diversity-equity-inclusion"}
                  linkText={"Diversity, Equity & Inclusion"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Our commitment to fostering a diverse, equitable, and inclusive community runs deep."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Career and Life Planning"}
                  linkUrl={"/student-life/career-life-planning"}
                  linkText={"Career & Life Planning"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Internships. Campus employment. Career fairs. Explore all the ways we prepare you for the world of work."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Community Engagement"}
                  linkUrl={"/student-life/civic-engagement"}
                  linkText={"Community Engagement"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "We believe life is for service. See how we prepare our students to make the world brighter."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Student Organizations"}
                  linkUrl={"/student-life/student-organizations"}
                  linkText={"Student Organizations"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Make your mark through our more than 150 clubs and organizations."
                  }
                />
              </li>
            </ul>
          </li>
          <li className="w-full md:w-4/12 px-2">
            <ul>
              <li className="py-2">
                <MenuItem
                  linkKey={"Campus Recreation & Intramurals"}
                  linkUrl={"/student-life/campus-recreation-intramurals"}
                  linkText={"Campus Recreation & Intramurals"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Explore all of our recreational, intramural, and club-sports offerings."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Health and Wellness"}
                  linkUrl={"/student-life/care-health-wellness"}
                  linkText={"Care, Health & Wellness"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Explore our holistic approach to keeping you healthy and happy."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Traditions"}
                  linkUrl={"/student-life/traditions"}
                  linkText={"Traditions"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "From Fox Day to Lip Sync, take part in our most cherished traditions."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"RollinsLife"}
                  linkUrl={"/rollinslife"}
                  linkText={"#RollinsLife"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Get a sneak peek at your life at Rollins through the Instagram adventures of your future classmates."
                  }
                />
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default StudentLifeMenu;
